import React from 'react';

import { Col } from '@notino/react-styleguide-v20';

import { FooterRowSkeleton } from '@sharedComponents/Skeletons';
import { StyledCheckoutWrapper } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { StyledDeliveryAndPaymentWrapper } from '../../styled';

import { DeliveryListSkeleton, PaymentListSkeleton } from './components';
import {
  StyledSubTitleWrapper,
  StyledSummary,
  StyledSummaryWrapper,
  StyledSurvey,
  StyledSurveyWrapper,
  StyledTitle,
  StyledTitleWrapper,
} from './styled';

export const DeliveryAndPaymentPageSkeleton: ReactFCV = () => (
  <StyledCheckoutWrapper data-testid="styled-checkout-wrapper">
    <StyledTitleWrapper data-testid="styled-title-wrapper">
      <StyledTitle data-testid="styled-title" width={12.375} />
    </StyledTitleWrapper>

    <StyledDeliveryAndPaymentWrapper data-testid="styled-delivery-and-payment-page-content-skeleton">
      <Col>
        <StyledSubTitleWrapper data-testid="styled-subtitle-wrapper1">
          <StyledTitle data-testid="styled-title1" width={12.375} />
        </StyledSubTitleWrapper>
        <DeliveryListSkeleton />
      </Col>
      <Col>
        <StyledSubTitleWrapper data-testid="styled-subtitle-wrapper2">
          <StyledTitle data-testid="styled-title2" width={12.375} />
        </StyledSubTitleWrapper>
        <PaymentListSkeleton />
      </Col>
    </StyledDeliveryAndPaymentWrapper>

    <StyledSummaryWrapper>
      <StyledSummary />
    </StyledSummaryWrapper>

    <StyledSurveyWrapper>
      <StyledSurvey width={20} />
    </StyledSurveyWrapper>

    <FooterRowSkeleton data-testid="footer-row-skeleton" />
  </StyledCheckoutWrapper>
);
